<script>
    import { onMount } from 'svelte';
    import * as d3 from 'd3';
    import { BASE_DATA_URL } from '../constants';
    import { buildCacheParam } from '../utils';
    import europeMapChart from '../charts/europeMapChart';

    let chartContainer;
    let dataType = 'totalCases';
    let chart;
    let mapData;
    let data;
    let isAnimating = false;
    let dataIndex;
    let intervalId;

    $: chart && chart.dataType(dataType);
    $: showGotoLatestDateButton = !isAnimating && data && dataIndex !== data.length - 1;

    onMount(async () => {
        const timeParse = d3.timeParse('%Y-%m-%d');
        [mapData, data] = await Promise.all([
            d3.json(`${BASE_DATA_URL}/europe.topojson`),
            d3.csv(`${BASE_DATA_URL}/europe_time_series.csv?d=${buildCacheParam()}`, d => ({
                ...d,
                date: timeParse(d.date),
                total_cases_per_million: +d.total_cases_per_million,
                new_cases_per_million: +d.new_cases_per_million,
                total_deaths_per_million: +d.total_deaths_per_million,
                new_deaths_per_million: +d.new_deaths_per_million
            }))
        ]);
        const dataMap = d3.group(data, d => d.date);
        data = Array.from(dataMap).sort((a, b) => a[0].getTime() - b[0].getTime());
        chart = europeMapChart()
                .mapData(mapData)
                .data(data)
                .dataType(dataType)
                .updateDataIndex(pDataIndex => {
                  dataIndex = pDataIndex;
                });
        dataIndex = chart.dataIndex();
        d3.select(chartContainer).call(chart);
    });

    function toggleAnimation() {
      isAnimating = !isAnimating;
      chart.isAnimating(isAnimating);
    }

    function gotoLatestDate() {
      chart.dataIndex(data.length - 1);
    }
</script>

<div class="chart-outer">
    <h2>How does Ireland compares to other countries?</h2>
    <div class="controls">
        <select class="select" bind:value={dataType}>
            <option value="totalCases">Total cases per million</option>
            <option value="newCases">New cases per million</option>
            <option disabled>-----------------------</option>
            <option value="totalDeaths">Total deaths per million</option>
            <option value="newDeaths">New deaths per million</option>
        </select>
        <button class="button" on:click={toggleAnimation}>{isAnimating ? 'Stop animation' : 'Start animation'}</button>
        {#if showGotoLatestDateButton}
            <button class="button" on:click={gotoLatestDate}>Go to latest date</button>
        {/if}
    </div>
    <div id="europe-map" bind:this={chartContainer}/>
</div>
